// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__GLAPw","pages":"Layout_pages__oxJll"};